export default "__VITE_ASSET__6a3f7c9d__"